export default __webpack_public_path__ + "static/media/sbir.ad4531e5.svg";